function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2b9b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2b9b"] = parcelRequire;
}
parcelRequire.register("irpW8", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $d6cede19b0c3dd09$export$6503ec6e8aabbaf; }, function (v) { return $d6cede19b0c3dd09$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $d6cede19b0c3dd09$export$f7ad0328861e2f03; }, function (v) { return $d6cede19b0c3dd09$export$f7ad0328861e2f03 = v; });
var $d6cede19b0c3dd09$export$6503ec6e8aabbaf;
var $d6cede19b0c3dd09$export$f7ad0328861e2f03;
"use strict";
var $d6cede19b0c3dd09$var$mapping = {};
function $d6cede19b0c3dd09$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$d6cede19b0c3dd09$var$mapping[keys[i]] = pairs[keys[i]];
}
function $d6cede19b0c3dd09$var$resolve(id) {
    var resolved = $d6cede19b0c3dd09$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$d6cede19b0c3dd09$export$6503ec6e8aabbaf = $d6cede19b0c3dd09$var$register;
$d6cede19b0c3dd09$export$f7ad0328861e2f03 = $d6cede19b0c3dd09$var$resolve;

});

var $a18a979826f88c90$exports = {};

(parcelRequire("irpW8")).register(JSON.parse('{"j5l7D":"about.28d1ef2f.js","Ur42K":"sumatrancat.e50a4151.riv"}'));


//# sourceMappingURL=about.74476584.js.map
